import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper } from '@material-ui/core';
import { EmptyState } from '@knockrentals/knock-shared-web-v2';
import { SyndicationOnboardingIcon } from '../../../Components/Icons';
import { makeCss } from '../../../knock-design-system';

const useCss = makeCss({
  paper: {
    flex: 1,
  },
});

export const ActivateChannelsSection = ({ onClick }) => {
  const css = useCss();
  return (
    <Paper css={css.paper} variant="outlined">
      <EmptyState gap={16} height="100%">
        <EmptyState.Image>
          <SyndicationOnboardingIcon />
        </EmptyState.Image>
        <EmptyState.Title>No Channels Activated Yet</EmptyState.Title>
        <Box width={400}>
          <EmptyState.Description align="center" color="secondary.500">
            Select properties to activate ILS channels and begin advertising
            properties across listing platforms.
          </EmptyState.Description>
        </Box>
        <EmptyState.Button onClick={onClick} variant="contained">
          Activate Channels
        </EmptyState.Button>
      </EmptyState>
    </Paper>
  );
};

ActivateChannelsSection.propTypes = {
  onClick: PropTypes.func,
};
